export default {
  common: {
    userSearchNoOptions: 'inga träffar',
  },
  form: {
    replacementQuestion_sv_primary_written:
      'Har du skrivit en laudatur eller eximia i modersmålets (svenska) studentexamen, eller är du i övrigt en skicklig och självstyrd skribent?',
    replacementQuestion_en_secondary_any:
      'Jag anser att jag redan i mina tidigare studier/arbetsliv/fritid har skaffat mig kunskaper och färdigheter som motsvarar de studier som ingår i min examen (CEFR B2).',

    replacementQuestion_sv_secondary_any:
      'Jag anser att jag redan i mina tidigare studier/arbetsliv/fritid har skaffat mig kunskaper och färdigheter som motsvarar de studier som ingår i min examen (CEFR B1).',
    mentoringQuestion_fi_secondary_any:
      'Vill du öva på vardagliga samtal tillsammans med andra och repetera grundläggande grammatik innan du deltar i finskakursen som ingår i examen?',
    finmuMentoringQuestion_fi_secondary_any:
      'Vill du öva på att tala och skriva på finska om aktuella ämnen och dina studier tillsammans med andra studenter?',
    challengeQuestion_fi_secondary_any:
      'Är du så nervös över att använda finska språket att du inte kan delta i en kurs där man övar språket tillsammans med andra?',
    previoslyDoneLangExplanation:
      '\nDe obligatoriska språk- och kommunikationsstudierna i examen kan ersättas med motsvarande studier som ingår i en tidigare inhemsk högskoleexamen och andra motsvarande tidigare prestationer.\n',
    searchedLanguageExplanation:
      '\nAlla kandidatexamina omfattar minst 10 studiepoäng obligatoriska språk- och kommunikationsstudier. Studierna genomförs enligt ditt utbildningsspråk på följande sätt:\n\n- Modersmål (finska/svenska) 3 sp\n- Andra inhemska språket (svenska/finska) 3 sp\n- Främmande språk (startnivå i engelska CEFR B2, i andra språk CEFR B1) 4 sp\n',
    primaryLanguageQuestion: 'Vilket är ditt undervisningsspråk?',
    languageQuestion: 'Vilket språk letar du efter kurser i?',
    primaryLanguageSpecificationQuestion: 'Vilken primär språktyp skulle du vilja välja?',
    previouslyDoneLangQuestion:
      'Jag har genomfört motsvarande studier eller andra motsvarande prestationer i en tidigare inhemsk högskoleexamen (avslutad eller oavslutad).',
    studyPeriodQuestion: 'Vilket datum är din önskade kurs?',
    replacementQuestion:
      'Jag anser att jag redan har förvärvat kunskaper och färdigheter motsvarande de som ingår i min examen i mina tidigare studier / arbetsliv / fritid.',
    mentoringQuestion: 'Behöver du övning innan du slutför en kurs som ingår i din examen?',
    challengeQuestion: 'För mig är det särskilt utmanande att lära sig ett språk och det gör mig väldigt nervös/rädd.',
    graduationQuestion: 'Tar du examen inom sex månader?',
    studyPlaceQuestion: 'Vilken studieform passar dig bäst?',
    integratedQuestion: 'Jag är intresserad av en kurs som är integrerad i mina studier inom mitt område.',
    independentQuestion: 'Jag vill arbeta självständigt eller autonomt.',
    flexibleQuestion: 'Jag vill ta en kurs med ett flexibelt schema.',
    moocQuestion: 'Vill du söka efter MOOCs (Massive Open Online Courses)?',
    collaborationQuestion: 'Visa samarbetspartnerkurser',
    multiPeriodQuestion: 'Sök kurser som sträcker sig över flera perioder',
    finnish: 'finska',
    swedish: 'svenska',
    english: 'engelska',
    yes: 'Ja',
    no: 'Nej',
    yesDefinitely: 'Ja (definitivt)',
    noDefinitely: 'Nej (definitivt)',
    neutralChoice: 'Jag bryr mig inte',
    both: 'Både',
    'language-both': 'Skriftlig och muntlig kommunikation',
    written: 'Skriftlig kommunikation',
    spoken: 'Röstkommunikation',
    summer: 'Sommar',
    intensivePeriod1: 'Intensivperiod 1',
    intensivePeriod2: 'Intensivperiod 2',
    period: 'Period',
    periods: 'Perioder',
    mentoringQuestionYes: 'Jag skulle vilja ha lite handledning innan jag avslutar mina studier.',
    mentoringQuestionNo: 'Jag känner inte att jag behöver motion.',
    graduationQuestionYes: 'Ja, inom sex månader.',
    graduationQuestionNo: 'Jag tar inte examen om sex månader.',
    studyPlaceRemote: 'Studier som inkluderar distansmöten',
    studyPlaceOnline: 'Självständiga nätstudier',
    studyPlaceCombined: 'Distansundervisning och undervisning ansikte mot ansikte',
    studyPlaceF2F: 'Studier som inkluderar möten på plats',
    studyPlaceNeutral: 'Studieformen spelar ingen roll',
    primaryLanguageExplanation:
      '\nDitt utbildningsspråk påverkar slutförandet av dina studier.\n\nLäs mer detaljerade instruktioner på sidan Studietjänst\n[Vad är ditt utbildningsspråk?](https://studies.helsinki.fi/ohjeet/artikkeli/mika-koulusivistyskieleni)\n',
    replacementQuestion_fi_primary_written:
      'Har du skrivit en laudatur eller eximia i modersmålets (finska) (eller S2) studentexamen, eller är du i övrigt en skicklig och självstyrd skribent?',
    replacementQuestion_fi_secondary_any:
      'Är du tvåspråkig (finska – svenska) eller använder du finska mycket och flytande i dina studier och/eller i ditt övriga liv?',
    challengeQuestion_fi_primary_written:
      'Är det svårt för dig att delta i genomföranden som inkluderar närvaro eller gemensamma onlinemöten på grund av din livssituation eller ångest?',
    challengeQuestion_fi_primary_spoken:
      'Jag tycker att sociala situationer är skrämmande och jag blir väldigt nervös i olika interaktionssituationer.',
    points: 'accuracy',
  },
  question: {
    extrainfo: 'Ytterligare information',
    checkInstructionsCrediting:
      'Läs mer detaljerade anvisningar på Studieinfo-sidan [Tillgodoräknande av kommunikations- och språkstudier för examen och ansök om ersättande av studier i Sisu](https://studies.helsinki.fi/ohjeet/artikkeli/opintojen-ja-osaamisen-hyvaksilukeminen?check_logged_in=1)',
    fromHere: 'härifrån',
    noExtrainfo: 'Ingen ytterligare information',
    noOrganisation: 'Ingen fakultet hittades',
    pickStudy: 'Välja en fakultet',
    skipped: 'Fråga överhoppad: ingen effekt',
    mandatory: 'Obligatorisk',
    close: 'Stäng',
  },
  app: {
    logout: 'Logga ut',
    questionaire: 'Förfrågan',
    recommendations: 'Rekommendationer',
    send: 'Stäng in',
    back: 'Tillbaka',
  },
  recommendations: {
    accurate: 'De mest exakta rekommendationerna:',
    all: 'alla rekommendationer (noggrannheten kan variera):',
    pointbased: 'Poängbaserade rekommendationer',
  },
  v2: {
    periodFilter: {
      title: 'Period',
    },
    retakeQuestions: 'Svara på startfrågorna',
    openFilters: 'Öppna filter',
    closeFilters: 'Stäng filter',
    opensInNewWindow: 'öppnas i ett nytt fönster',
    moreOptions: 'Fler alternativ',
    filtersRegion: 'Kursfilter',
    appDescription:
      'Polku är Helsingfors universitets språkcentrums kursrekommenderare. Den föreslår språk- och kommunikationskurser som passar dina studier. Börja med att svara på startfrågorna om din studierätt och ditt utbildningsspråk, och avgränsa sedan förslagen med frågorna i navigeringen Kursfilter. Förslagen uppdateras så snart du ändrar ett svar, och antalet matchande kurser meddelas i området Kursrekommendationer.',
    filter: {
      noMatches: 'inga matchande kurser',
      matchCount_one: '{{count}} matchande kurs',
      matchCount_other: '{{count}} matchande kurser',
      removeSelection: 'Ta bort valet {{selection}}',
      mandatoryStaysOpen: 'Förblir öppen tills du svarar på denna obligatoriska fråga',
    },
    languageSelector: 'Språk',
    universityLogoAlt: 'Helsingfors universitet',
    modal: {
      close: 'Stäng',
      warning: 'Varning',
    },
    skipQuestions: 'Hoppa över frågorna',
    done: 'Klar',
    welcomeText: 'Svara först på några inledande frågor. Du kan ändra dessa senare.',
    results: {
      heading: 'Kursrekommendationer',
      loading: 'Laddar kursrekommendationer',
      loadingFilters: 'Laddar filter',
      unansweredMandatory_one: 'Svara ännu på den obligatoriska frågan: {{question}}',
      unansweredMandatory_other: 'Svara ännu på {{count}} obligatoriska frågor, nästa: {{question}}',
      count_one: '{{count}} kurs hittades',
      count_other: '{{count}} kurser hittades',
    },
    noRecommendations: {
      title: 'Inga kurser hittades',
      unansweredMandatory: 'Svara på den obligatoriska frågan',
      openFilterQuestion: 'Öppna filter: {{question}}',
      changeSelectionsButton: 'Ändra dina val',
      resetButton: 'Rensa val',
      resetConfirmationTitle: 'Återställ alla val?',
      resetConfirmationDescription: 'Detta rensar dina nuvarande svar och återställer standardfiltren.',
      resetConfirmationCancel: 'Avbryt',
      resetConfirmationConfirm: 'Återställ val',
    },
    appTitle: 'Polku',
    adminButton: 'ADMIN',
    courseTags: {
      title: 'Kurstaggar',
      course: 'Kurs',
      matched: '{{count}} kurser matchar den nuvarande sökningen',
      columns: 'Taggkolumner ({{shown}}/{{total}})',
      columnsAll: 'Alla',
      columnsStudy: 'Studietaggar',
      columnsFaculty: 'Fakultetstaggar',
      cancel: 'Avbryt',
      close: 'Stäng',
      state: {
        inherited: 'ärvd från studieavsnittet',
        customCodeUrn: 'från en custom code urn i Sisu',
        added: 'tillagd på denna förverkligande',
        both: 'både i apparaatti och i Sisu',
        ignored: 'ignorerad på denna förverkligande',
        unset: 'inte satt',
      },
      editing: {
        label: 'Redigeras',
        new: 'Ny version',
        newTitle: 'Skapa en ny version',
        newConfirm: 'Skapa version',
        published: 'Den tillämpade versionen (skrivskyddad)',
        readOnly: 'Den tillämpade versionen kan inte redigeras. Välj eller skapa en version för att redigera taggar.',
        editingVersion: 'Redigerar versionen ”{{name}}”. Ändringarna sparas i den direkt.',
      },
      publish: {
        liveVersion: 'Versionen i bruk är ”{{name}}”.',
        liveUnknown: 'Taggningen i bruk är inte sparad som någon version.',
        publishVersion: 'Granska och tillämpa',
        reviewTitle: 'Granska ändringarna innan de tillämpas',
        confirmApply: 'Tillämpa ändringarna',
        nameLabel: 'Versionens namn',
        nameHelp: 'Lämnas det tomt namnges versionen efter tidpunkten den skapades.',
        descriptionLabel: 'Beskrivning (valfri)',
        descriptionHelp: 'Sparas med versionen.',
      },
      tabs: {
        realisations: 'Förverkliganden',
        matched: '{{count}} studieavsnitt i den nuvarande sökningen',
        courseUnits: 'Studieavsnitt',
        vocabulary: 'Taggar',
        snapshots: 'Versioner',
      },
      bulk: {
        open: 'Massapplicera taggar',
        title: 'Applicera taggar på alla matchande kurser',
        tags: 'Taggar',
        tagsHint: 'Skriv för att filtrera, Enter väljer den markerade taggen',
        mode: {
          add: {
            label: 'Lägg till',
            description: 'Ger alla matchande kurser denna tagg.',
          },
          ignore: {
            label: 'Ignorera',
            description:
              'Markerar taggen som ignorerad på alla matchande kurser, så att en tagg som ärvts från studieavsnittet inte längre gäller dem.',
          },
          clear: {
            label: 'Rensa',
            description: 'Tar bort förverkligandets egna inställning, så att taggen bestäms av studieavsnittet igen.',
          },
        },
        newTagNote: 'Endast befintliga taggar kan läggas till. Skapa en ny tagg först under fliken Taggar.',
        explanation: 'Detta gäller alla kurser som matchar sökningen, inte bara den synliga sidan.',
        previewPending: 'Välj minst en tagg för att se hur många kurser som skulle ändras.',
        previewCount: '{{count}} kurser matchar.',
        confirm: 'Applicera på alla {{count}} matchande kurser',
      },
      cu: {
        explanation:
          'Taggar som sätts här ärvs av alla förverkliganden av studieavsnittet. Ett förverkligande kan ignorera en ärvd tagg.',
        courseCode: 'Kurskod',
        courseUnit: 'Studieavsnitt',
        realisations: 'Förverkliganden',
      },
      vocabulary: {
        key: 'Nyckel',
        description: 'Beskrivning',
        add: 'Lägg till tagg',
        delete: 'Radera',
        deleteConfirm:
          'Radera taggen {{key}}? Alla dess kopplingar till studieavsnitt och förverkliganden raderas också.',
        duplicate: 'En tagg med denna nyckel finns redan.',
        invalid: 'Ogiltig taggnyckel.',
      },
      snapshots: {
        name: 'Versionsnamn',
        description: 'Beskrivning',
        createdAt: 'Sparad',
        save: 'Spara version',
        compare: 'Jämför',
        edit: 'Redigera',
        editTaggingConfirm:
          'Öppna versionen {{name}} för redigering? Det nuvarande utkastet ersätts med dess innehåll.',
        activate: 'Ta i bruk',
        activeShort: 'I bruk',
        activeIs: 'I bruk: {{name}}',
        activeUnknown: 'I bruk: taggning som inte är sparad som någon version',
        activateConfirm:
          'Ta versionen {{name}} i bruk? Den ersätter den nuvarande taggningen och går direkt till rekommendationen.',
        restore: 'Återställ',
        delete: 'Radera',
        empty: 'Inga sparade versioner ännu.',
        restoreConfirm: 'Återställ taggningen {{name}}? Nuvarande tillstånd sparas först som en version.',
        deleteConfirm: 'Radera denna version?',
        export: 'Exportera',
        import: 'Importera',
        exportFailed: 'Exporten misslyckades',
        importFailed: 'Importen misslyckades',
        importConfirm: 'Importera {{fileName}}? Detta ersätter alla nuvarande taggningar.',
        diffTitle: 'Skillnader mot den nuvarande taggningen',
        diffUnchanged: 'Den nuvarande taggningen är identisk med denna version.',
        diffVocabularyChanges: 'Ändringar i taggarna',
        diffCourseChanges: 'Ändringar i kursernas taggar',
        diffRealisationChanges: 'Ändringar i enskilda förverklingandens taggar',
        diffBefore: 'Före: {{tags}}',
        diffNoTags: 'inga taggar',
        diffUnknownCourse: 'Kursen hittades inte',
        diffLoading: 'Laddar kursnamn...',
      },
    },
    adminNav: {
      back: 'Tillbaka',
      backToApp: 'Tillbaka till tjänsten',
      overview: 'Översikt',
      courses: 'Kurser',
      stats: 'Statistik',
      feedback: 'Användarfeedback',
      loginAs: 'Logga in som',
      updater: 'Uppdaterare',
      courseTags: 'Kurstaggar',
      errorTest: 'Feltest',
    },
    admin: {
      loading: 'Laddar...',
      settingsTabs: {
        texts: 'Textinställningar',
        filters: 'Filterinställningar',
        codes: 'Kurskoder',
        languages: 'Språkkategorier',
      },
      recommendationCodes: {
        title: 'Rekommenderade kurskoder',
        intro:
          'Kurskoderna som rekommenderas utgående från fakultet och språkval. En kurs syns i rekommendationerna först när dess förverkligande har märkts i Sisu med fakultetens kk-apparaatti-kod.',
        loading: 'Laddar...',
        newCode: 'Lägg till en kod',
        editCode: 'Redigera kod',
        organisation: 'Fakultet',
        language: 'Språk',
        courseCode: 'Kurskod',
        courseCodeHelp:
          'Till exempel KK-ENERI. Tillåtna tecken: bokstäver, siffror, bindestreck, snedstreck och punkt.',
        search: 'Sök kurskod',
        matrixIntro:
          'En rad per kurskod. En bock betyder att koden rekommenderas för den fakulteten. Ett klick lägger till eller tar bort koden direkt, och ett nytt klick på samma ruta återställer läget.',
        coverage: '{{count}} / {{total}}',
        coverageHeader: 'Fakulteter',
        toggleCell: '{{courseCode}} — {{faculty}}',
        allValues: 'Alla',
        anyValue: 'Alla',
        save: 'Spara',
        cancel: 'Avbryt',
        saveFailed: 'Sparandet misslyckades',
        export: 'Exportera',
        exportFailed: 'Exporten misslyckades',
        import: 'Importera',
        importConfirm: 'Importera koder från {{fileName}}?',
        importFailed: 'Importen misslyckades',
        importCompleted: 'Importerade {{count}} koder',
        parseFailed: 'Kunde inte läsa filen',
        languagesTitle: 'Språkkategorier',
        languagesIntro:
          'En språkkategori anger vilka språkval dess kurskoder gäller. Namnet visas bara i gränssnittet, matchningen styrs av språket, typen och specifikationen.',
        languageIntro:
          'Namnet visas bara i gränssnittet. Språk, typ och specifikation avgör när kategorin rekommenderas.',
        languageName: 'Namn',
        newLanguage: 'Lägg till en språkkategori',
        editLanguage: 'Redigera språkkategori',
        deleteLanguage: 'Radera språkkategori',
        confirmDeleteLanguage: 'Radera språkkategorin {{name}}?',
        lang: 'Språk',
        languageType: 'Typ',
        specification: 'Specifikation',
        langOption: {
          fi: 'Finska',
          sv: 'Svenska',
          en: 'Engelska',
        },
        languageTypeOption: {
          primary: 'Modersmål',
          secondary: 'Det andra inhemska språket',
        },
        specificationOption: {
          spoken: 'Talkommunikation',
          written: 'Skriftlig kommunikation',
        },
        table: {
          actions: 'Funktioner',
          codeCount: 'Koder',
        },
      },
      errorTest: {
        pageTitle: 'Feltest',
        description:
          'Utlös ett avsiktligt fel för att verifiera att felrapporteringen fungerar. Fel skickas till Sentry endast i produktion.',
        backendOk: 'Servern svarade utan problem — inget fel utlöstes.',
        backendTriggered: 'Serverfel utlöst (status {{status}}).',
        frontendTriggered: 'Fel utlöst i webbläsaren.',
        causeBackend: 'Utlös fel på servern',
        causeFrontend: 'Utlös fel i webbläsaren',
      },
      courses: {
        pageTitle: 'KK-kurser',
        total: 'Visar endast förverkliganden vars kurskod börjar med KK-. Totalt: {{total}}',
        loading: 'Laddar kurser...',
        visit: 'Öppna',
        table: {
          name: 'Kursnamn',
          codes: 'Kurskoder',
          customUrns: 'Anpassade URN:er',
          dates: 'Datum',
          review: 'Granskning',
          reviewUpdated: 'Granskning uppdaterad',
          actions: 'Åtgärder',
        },
        search: {
          nameLegend: 'Namn',
          nameField: 'Sök',
          urnLegend: 'URN',
          includeLegend: 'Inkludera',
          excludeLegend: 'Exkludera',
          urnsToInclude: 'URN:er att inkludera',
          urnsToExclude: 'URN:er att exkludera',
          includeOrTitle: 'Behåll kurser som matchar någon av URN:erna till vänster',
          includeAndTitle: 'Behåll endast kurser som matchar alla URN:er till vänster',
          excludeOrTitle: 'Ta bort kurser som matchar någon av URN:erna till vänster',
          excludeAndTitle: 'Ta bort endast kurser som matchar alla URN:er till vänster',
          tagLegend: 'Taggar',
          tagsToInclude: 'Taggar att inkludera',
          tagsToExclude: 'Taggar att utesluta',
          tagIncludeOrTitle: 'Visa kurser som har någon av taggarna till vänster',
          tagIncludeAndTitle: 'Visa endast kurser som har alla taggar till vänster',
          tagExcludeOrTitle: 'Ta bort kurser som har någon av taggarna till vänster',
          tagExcludeAndTitle: 'Ta bort endast kurser som har alla taggar till vänster',
          courseCodeLegend: 'Kurskod',
          courseCodeInclude: 'Inkludera',
          courseCodeExclude: 'Exkludera (kommaseparerat)',
          reviewLegend: 'Granskning',
          statusField: 'Status',
          statusAll: 'Alla',
          statusReviewed: 'Granskad',
          statusNotReviewed: 'Inte granskad',
          courseDateLegend: 'Kursdatum',
          courseDateTooltip: 'Behåller endast kurser som både börjar och slutar inom intervallet',
          from: 'Från',
          to: 'Till',
          submit: 'Sök',
        },
      },
      review: {
        reviewed: 'Granskad',
        notReviewed: 'Inte granskad',
        commentPlaceholder: 'Lägg till kommentar',
        saved: 'Granskningen sparad',
        saveButton: 'Spara granskning',
        saveFailed: 'Det gick inte att spara granskningen',
      },
      stats: {
        pageTitle: 'Användningsstatistik',
        legendHint: 'Klicka på en förklaring, en stapel eller en sektor för att dölja organisationen.',
        hideAll: 'Dölj alla',
        showAll: 'Visa alla',
        start: 'Från',
        end: 'Till',
        groupBy: 'Gruppera efter',
        hour: 'Timme',
        day: 'Dag',
        month: 'Månad',
        year: 'År',
        last14Days: 'Senaste 14 dagarna',
        exportCsv: 'Ladda ner CSV',
        csv: {
          period: 'Intervall',
          faculty: 'Fakultet',
          phase1: 'Kandidatprogram',
          phase2: 'Magisterprogram',
          count: 'Användare',
        },
        uniqueUsers: 'Unika användare',
        faculty: 'Fakultet',
        loading: 'Laddar statistik...',
        noVisits: 'Inga besök under det valda intervallet.',
        programmes: {
          title: 'Utbildningsprogram',
          phase1: 'Kandidatprogram',
          phase2: 'Magisterprogram',
          unknown: 'Okänt',
          noData: 'Inga utbildningsprogramuppgifter under det valda intervallet.',
        },
      },
      backendLocales: {
        loading: 'Laddar texter...',
        title: 'Texter från servern',
        intro:
          'Texter som kan variera enligt fakultet och språkval. Varje nyckel bör ha en allmän text så att alla användare ser något.',
        table: {
          key: 'Nyckel',
          description: 'Beskrivning',
          textCount: 'Texter',
          textFi: 'Text (fi)',
          actions: 'Åtgärder',
        },
        anyValue: 'vilken som helst',
        organisation: 'Fakultet',
        lang: 'Kursens språk',
        primaryLanguage: 'Utbildningsspråk',
        specification: 'Prestationssätt',
        langOption: {
          fi: 'finska',
          sv: 'svenska',
          en: 'engelska',
        },
        specificationOption: {
          writtenAndSpoken: 'skriftligt och muntligt',
          written: 'skriftligt',
          spoken: 'muntligt',
        },
        specificationHelp:
          'Prestationssättet frågas av användaren endast när kursens språk är samma som utbildningsspråket.',
        specificationUnreachable:
          'Med dessa språkval frågas prestationssättet inte av användaren, så det är låst till "vilken som helst".',
        newKey: 'Ny nyckel',
        editKey: 'Redigera nyckel',
        deleteKey: 'Ta bort nyckel',
        keyLabel: 'Nyckel',
        keyHelp: 'Identifierare som används i koden, till exempel noRecommendations.additionalInfo',
        descriptionLabel: 'Beskrivning',
        descriptionHelp: 'Berätta var den här texten visas för användaren. Skriv på ditt eget språk.',
        newText: 'Ny text',
        editText: 'Redigera text',
        deleteText: 'Ta bort text',
        textLabel: 'Text (markdown)',
        textToShow: 'Text som visas',
        whenShown: 'När texten visas',
        preview: 'Förhandsvisning',
        toggleTexts: 'Visa texter för nyckeln {{key}}',
        noCatchAll: 'ingen allmän text, en del användare ser ingenting',
        save: 'Spara',
        cancel: 'Avbryt',
        saveFailed: 'Sparandet misslyckades',
        confirmDeleteKey:
          'Ta bort nyckeln {{key}} och dess {{count}} texter? Koden som använder nyckeln börjar logga ett fel.',
        confirmDeleteValue: 'Ta bort den här texten?',
        export: 'Exportera JSON',
        import: 'Importera JSON',
        exportFailed: 'Exporten misslyckades',
        importConfirm: 'Importera filen {{fileName}}? Befintliga texter uppdateras.',
        importFailed: 'Importen misslyckades',
        importCompleted: 'Importen klar: {{count}} nycklar behandlade.',
        parseFailed: 'Filen kunde inte läsas',
      },
      filterConfig: {
        loading: 'Laddar filter...',
        title: 'Filterinställningar',
        table: {
          order: 'Ordning',
          id: 'ID',
          shortNameFi: 'Kortnamn (fi)',
          enabled: 'Aktiverad',
          actions: 'Åtgärder',
        },
        edit: 'Redigera',
        restore: 'Återställ',
        restoring: 'Återställer...',
        addFilter: '+ Lägg till filter',
        export: 'Exportera inställningar',
        import: 'Importera inställningar',
        restoreConfirm: 'Återställ filtret till standardvärdena? Detta skriver över nuvarande inställningar.',
        noSeedDefaults: 'Detta filter har inga standardvärden att återställa',
        restoreFailed: 'Det gick inte att återställa filtrets standardvärden',
        exportFailed: 'Det gick inte att exportera filterinställningarna',
        importConfirm:
          'Importera filterinställningar från {{fileName}}?\n\nDetta uppdaterar befintliga filter med de importerade inställningarna.',
        importFailed: 'Det gick inte att importera filterinställningarna',
        importCompleted:
          'Importen klar:\n{{updated}} filter uppdaterade\n{{skipped}} filter överhoppade\n{{errors}} fel',
        parseFailed: 'Det gick inte att läsa eller importera filen',
      },
      filterEdit: {
        createTitle: 'Skapa filter',
        editTitle: 'Redigera: {{id}}',
        tabGeneral: 'Allmänt',
        tabVariants: 'Varianter ({{amount}})',
        cancel: 'Avbryt',
        save: 'Spara',
        unknownError: 'Okänt fel',
        networkError: 'Nätverksfel',
        id: 'ID',
        idHelper: 'Små bokstäver, siffror och bindestreck',
        displayType: 'Visningstyp',
        displayTypeNone: '— ingen —',
        displayOrder: 'Visningsordning',
        parentFilterId: 'Överordnat filter-ID (valfritt)',
        mandatory: 'Obligatorisk',
        showInWelcomeModal: 'Visa i välkomstfönstret',
        hideInCurrentFiltersDisplay: 'Dölj i nuvarande val',
        hideInFilterSidebar: 'Dölj i sidopanelen',
        enabled: 'Aktiverad',
        shortName: 'Kortnamn',
        explanation: 'Förklaring (valfritt)',
        explanationHint: '(frågetecken-ikonen)',
        extraInfo: 'Extra information (valfritt)',
        extraInfoHint: '(visas när visningstypen är info-only)',
        language: 'Språk',
        langFi: 'Finska',
        langSv: 'Svenska',
        langEn: 'Engelska',
        optionId: 'Alternativets ID',
        valueOverride: 'Värdeåsidosättning',
        selectedByDefault: 'Vald som standard',
        nullValue: '— null —',
        optionName: 'Namn',
        variantName: 'Variantens namn',
        variantFallback: 'Variant {{number}}',
        skipped: 'Överhoppad',
        questionText: 'Frågetext',
        explanationOverride: 'Åsidosatt förklaring (valfritt)',
        explanationOverrideField: 'Åsidosatt förklaring',
        options: 'Alternativ ({{amount}})',
        addOption: 'Lägg till alternativ',
        addVariant: 'Lägg till variant',
      },
    },
    updater: {
      pageTitle: 'Uppdaterare',
      runButton: 'Kör uppdaterare',
      coursesRunButton: 'Uppdatera kurser',
      coursesConfirmBody: 'Detta uppdaterar endast kursdata. Uppdaterarens övriga steg hoppas över.',
      alreadyRunning: 'En körning pågår redan.',
      confirmTitle: 'Kör uppdaterare?',
      confirmBody:
        'Detta utlöser en fullständig omsynkronisering av alla kurs-, användar- och organisationsdata från importören. Åtgärden körs i bakgrunden och kan ta flera minuter.',
      confirmButton: 'Kör',
      cancelButton: 'Avbryt',
      runStarted: 'Uppdateringskörning startad.',
      runFailed: 'Det gick inte att starta uppdateringskörningen.',
      historyTitle: 'Körhistorik',
      loading: 'Laddar...',
      empty: 'Inga körningar registrerade ännu.',
      table: {
        id: 'ID',
        status: 'Status',
        runtype: 'Körningstyp',
        triggeredBy: 'Utlöst av',
        started: 'Startad',
        finished: 'Avslutad',
        duration: 'Varaktighet',
        error: 'Fel',
      },
      status: {
        running: 'Körs',
        success: 'Lyckad',
        failed: 'Misslyckad',
      },
    },
    feedback: {
      openButton: 'Ge feedback',
      title: 'Ge feedback',
      description: 'Berätta hur vi kan förbättra tjänsten.',
      textLabel: 'Feedback',
      starsLabel: 'Stjärnor',
      starsValue_one: '{{count}} stjärna',
      starsValue_other: '{{count}} stjärnor',
      starsEmpty: 'Ingen bedömning',
      sendMetadata: 'skicka metadata',
      sendMetadataInfo:
        'Om du väljer detta skickas dina filterval och rekommendationer med formuläret. Feedbacken är fortfarande anonym.',
      viewMetadata: 'Visa metadata',
      metadataDialogTitle: 'Förhandsvisning av metadata',
      metadataDialogDescription: 'Här visas metadata som kan skickas tillsammans med din feedback.',
      send: 'Skicka feedback',
      cancel: 'Avbryt',
      sent: 'Feedback skickad',
      failed: 'Det gick inte att skicka feedback',
      sendContactEmail: 'Skicka kontaktuppgifter',
      sendContactEmailInfo:
        'Detta bifogar din helsinki.fi-e-postadress till feedbacken. Välj detta om du vill att vi ska kunna svara på din feedback. Feedbacken är inte anonym om du väljer detta alternativ.',
      attachedEmail: 'Bifogad e-post: {{email}}',
      admin: {
        backToAdmin: 'Tillbaka till admin',
        pageTitle: 'Användarfeedback',
        start: 'Start',
        end: 'Slut',
        last12Months: 'Senaste 12 månaderna',
        loading: 'Laddar feedback...',
        empty: 'Ingen feedback har skickats än.',
        readComment: 'Läs',
        dialogTitle: 'Feedbackkommentar',
        close: 'Stäng',
        starsValue: '{{stars}} / 5 stjärnor',
        emailFilterLabel: 'Kontakt-e-post',
        emailFilterAll: 'Alla',
        emailFilterHas: 'Har e-post',
        emailFilterNo: 'Ingen e-post',
        emailSearchLabel: 'Sök på e-post',
        table: {
          date: 'Datum',
          stars: 'Stjärnor',
          version: 'Version',
          email: 'E-post',
          text: 'Feedback',
          metadata: 'Metadata',
          hasMetadata: 'Ja',
          noMetadata: 'Nej',
          action: 'Åtgärd',
        },
        metadata: {
          title: 'Rekommendationsmetadata',
          filterSelections: 'Filterval',
          unnamedCourse: 'Namnlös kurs',
          recommendations: 'Rekommendationer',
          points: 'Poäng',
          courseCodes: 'Kurskoder',
          period: 'Period',
        },
        massAction: 'Massåtgärd',
        deleteOlderThanPreview: 'Tar bort {{count}} feedbackposter',
        deleteSelected: 'Ta bort valda ({{count}})',
        deleteOlderThanLabel: 'Ta bort feedback äldre än',
        prefill180Days: '180 dagar sedan',
        deleteOlderThanButton: 'Ta bort',
        confirmDeleteTitle: 'Bekräfta borttagning',
        confirmDeleteBody: 'Detta tar permanent bort {{count}} feedbackposter. Det går inte att ångra.',
        confirmDeleteButton: 'Ta bort',
        deleteSuccess: 'Tog bort {{count}} feedbackposter',
        deleteError: 'Det gick inte att ta bort feedback',
      },
    },
    loginPrompt: 'Vänligen logga in:',
    loginLink: 'här',
    loadingFilters: 'Laddar filter...',
    sortBy: 'Sortera efter',
    sortRecommended: 'Rekommenderad',
    sortName: 'Namn',
    sortDate: 'Datum',
    sortPeriod: 'Period',
    recommendationSearch: {
      label: 'Sök kurser efter namn',
      placeholder: 'Skriv kursens namn',
      resultsCount: 'Visar {{shown}} av {{total}} kurser',
      noMatchesTitle: 'Inga matchande kurser hittades',
      noMatchesDescription: 'Prova ett annat kursnamn eller rensa sökningen för att se alla rekommenderade kurser.',
      clearButton: 'Rensa sökning',
    },
  },
  course: {
    show: 'Kurssida',
    showCourse: 'Kurssida: {{course}}',
    credits: 'sp',
    reasons: 'grundläggande',
    periodName: 'period',
    examWeek: 'Tentamensvecka',
    intensivePeriod: 'Intensivperiod',
  },
  opintotarjonta: {
    mooc: 'mooc',
  },
  loginAsPage: {
    title: 'användarsökning',
    userHeader: 'användare',
  },
  filter: {
    period: 'Studieperiod',
    periods: 'Studieperioder',
    organisation: 'Organisation',
    language: 'Språk',
    graduation: 'Examen inom sex månader',
    mentoring: 'Behöver övning innan kurs',
    integrated: 'Intresserad av integrerad kurs',
    studyPlace: 'Studieplats',
    replacement: 'Tidigare förvärvad kunskap',
    challenge: 'Språkinlärning utmanande',
    independent: 'Vill arbeta självständigt',
    flexible: 'Vill ha flexibelt schema',
    mooc: 'Sök MOOC-kurser',
    finmu: 'FinMU relaterad',
    multiPeriod: 'Kurslängd',
    allSelected: 'Alla',
  },
  filterShortName: {
    'Opinto-oikeus': 'Studierätt',
    Koulukieli: 'Skolspråk',
    Kurssi: 'Kurs',
    Viestintä: 'Kommunikation',
    Aikaisemmatopinnot: 'Tidigare studier',
    Korvaava: 'Ersättande',
    Valmentava: 'Förberedande',
    Finmu: 'Finmu',
    Edistynyt: 'Anpassad',
    Valmistuville: 'För examinerande',
    Integroitu: 'Integrerad',
    Itsenäinen: 'Självständig',
    Opetusmuoto: 'Undervisningsform',
    Lukuvuosi: 'Läsår',
    Periodi: 'Period',
    MOOC: 'MOOC',
    'opintotarjonta:mooc': 'mooc',
    Yhteistyo: 'Samarbete',
    Kurssinpituus: 'Kurslängd',
    Exam: 'Tentamen',
  },
}
